const CHROME_QNAP = 'Chrome/QNAP';

let _isKiosk: boolean | undefined;

/**
 * Returns true if this is running in kiosk mode on a QNAP.
 */
export function isKiosk(): boolean {
  if (_isKiosk === undefined) {
    _isKiosk = typeof window !== 'undefined' && window.navigator.userAgent === CHROME_QNAP;
  }
  return _isKiosk;
}
